import {
  CLEAR_VEHICULOS_ACTION,
  FETCH_VEHICULOS,
} from './actions.type';

import {
  SET_ERROR,
  // CLEAR_ALERT_DIALOG,
  CLEAR_VEHICULOS,
  FETCHED_VEHICULOS,
  FETCHING_VEHICULOS,
  /*
  FETCHING_VEHICULO,
  // FETCHED_VEHICULO,
  SUBMITED_VEHICULO,
  SUBMIT_VEHICULO_ERROR,
  RESET_VEHICULO_SUBMIT,
  RESET_VEHICULO_PROCESSING,
  STARTED_VEHICULO_PROCESSING,
  */
} from './mutations.type';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  /*
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  */
  loading_vehiculo: false,
  loading_vehiculos: false,
  submited_vehiculo: false,
  processing_vehiculo: false,
};

const getters = {
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
  is_loading() {
    return state.loading_vehiculos;
  },
  vehiculo_processing() {
    return state.processing_vehiculo;
  },
  vehiculo_submited() {
    return state.submited_vehiculo;
  },
};

const actions = {
  [FETCH_VEHICULOS](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_VEHICULOS);
      ApiService.query('vehiculos', { params: data })
        .then(({ data }) => {
          // context.commit(SET_VEHICULOS, data);
          context.commit(FETCHED_VEHICULOS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_VEHICULOS);
        });
    });
  },
  [CLEAR_VEHICULOS_ACTION](context) {
    context.commit(CLEAR_VEHICULOS);
  },
};

const mutations = {
  /*
  [SUBMITED_VEHICULO](state, data) {
    state.submited_vehiculo = true;
    state.alert = true;
    if (data.code !== 0) {
      state.alertType = 'error';
      state.alertMessage = data.message;
    } else {
      state.alertType = 'success';
      state.alertMessage = data.message;
    }
  },
  [SUBMIT_VEHICULO_ERROR](state, data) {
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
    state.processing_vehiculo = false;
  },
  [RESET_VEHICULO_SUBMIT](state) {
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
    state.submited_vehiculo = false;
  },
  */
  [FETCHING_VEHICULOS](state) {
    state.loading_vehiculos = true;
  },
  [FETCHED_VEHICULOS](state) {
    state.loading_vehiculos = false;
  },
  /*
  [FETCHING_VEHICULO](state) {
    state.loading_vehiculo = true;
  },
  [FETCHED_VEHICULO](state) {
    state.loading_vehiculo = false;
  },
  [RESET_VEHICULO_PROCESSING](state) {
    state.processing_vehiculo = false;
  },
  [STARTED_VEHICULO_PROCESSING](state) {
    state.processing_vehiculo = true;
  },
  */
  /*
  [CLEAR_ALERT_DIALOG](state) {
    state.alertDialog = false;
    state.alertDialogMessage = '';
    state.alertDialogType = 'success';
  },
  */
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
